"use memo"

import { AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2'
import { useCallback, useMemo } from 'react'
import { allowedCommissionTypes } from 'pages/finance/commission/commission/CommissionEnums'
import AgreementCommissionStageSteps from 'pages/campaigns/components/campaignTasks/AgreementCompliance/AgreementCommissionStageSteps'
import { TaskModalPageProps } from '../TaskModalPageProps'

const NswAgreementComplianceTypePage = ({
  task,
  toggleTaskStep,
  commissionDetails,
  currentCommissionInfo,
  setCommissionDetailsValid,
  onCommissionUpdated,
}: TaskModalPageProps) => {
  const taskSteps = useMemo(() => task.taskSteps ?? [], [task.taskSteps])

  if (!setCommissionDetailsValid || !onCommissionUpdated) {
    return null
  }

  const updateTaskStep = useCallback(
    (step: { order?: number }, isChecked: boolean) => {
      toggleTaskStep(step.order ?? 0, isChecked)
    },
    [toggleTaskStep]
  )

  const handleCommissionDetailsValid = useCallback(
    (valid: boolean) => {
      setCommissionDetailsValid(valid)
    },
    [setCommissionDetailsValid]
  )

  return (
    <AgxSpacer direction="vertical" gap="spacing-3xl" fill>
      <AgxTypography
        size="large"
        type="label"
        id="step2title"
        color="var(--text-primary)"
      >
        Step 2: Confirm Commission
      </AgxTypography>
      <AgreementCommissionStageSteps
        commissionDetails={commissionDetails}
        onCommissionUpdated={onCommissionUpdated}
        allowedCommissionTypes={allowedCommissionTypes}
        currentCommissionInfo={currentCommissionInfo}
        tasksStage={taskSteps}
        updateTaskStep={updateTaskStep}
        setCommissionDetailsValid={handleCommissionDetailsValid}
      />
    </AgxSpacer>
  )
}

export default NswAgreementComplianceTypePage
